import { render, staticRenderFns } from "./CommonHero.vue?vue&type=template&id=6240fb50"
import script from "./CommonHero.vue?vue&type=script&lang=js"
export * from "./CommonHero.vue?vue&type=script&lang=js"
import style0 from "./CommonHero.vue?vue&type=style&index=0&id=6240fb50&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports